const MiniQTable = ({item, t}) => {
    return <>
        <div className="d-inline-block text-center ps-2 pe-3 border-end">
            <div className="fw-medium">Tipo</div>
            <div>Único</div>
        </div>
        <div className="d-inline-block text-center ps-2 pe-3 border-end">
            <div className="fw-medium">{t("power")}</div>
            <div>{item.values.power}</div>
        </div>
        <div className="d-inline-block text-center ps-2 pe-3 border-end">
            <div className="fw-medium">{t("vacuum")}</div>
            <div>{item.values.vacuum}</div>
        </div>
        <div className="d-inline-block text-center ps-2 pe-3">
            <div className="fw-medium">{t("filling")}</div>
            <div>{item.values.filling}</div>
        </div>
    </>
}
export default MiniQTable